const s = {
  name: "Kiosk",
  dimensions: { width: 22, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 22 40" style="enable-background:new 0 0 22 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M10,25H4v-2h6V25z"/>
		<path class="st0" d="M18,23h-6v7h6V23z M14,28v-3h2v3H14z"/>
		<path class="st0" d="M3,0C1.3,0,0,1.3,0,3v34c0,1.7,1.3,3,3,3h16c1.7,0,3-1.3,3-3V3c0-1.7-1.3-3-3-3H3z M2,3c0-0.6,0.4-1,1-1h16
			c0.6,0,1,0.4,1,1v16H2V3z M2,21h18v16c0,0.6-0.4,1-1,1H3c-0.6,0-1-0.4-1-1V21z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Kiosk
};
